import { Observer } from "mobx-react";
import { device } from "../../../WSUtils/constants/mediaQueries";
import { Menu } from "primereact/menu";
import React, { useContext, useRef, useState } from "react";
import { UserInfoContext } from "../../../WSUtils/UserInfoContext";
import styled from "styled-components";
import { getItem } from "../NavMenu/getItem";
import { Button } from "primereact/button";
import { navItems } from "../NavMenu/navItems";

export const MobileNav: React.FC = () => {
  const userInfo = useContext(UserInfoContext);

  return (
    <Observer
      render={() => (
        <StyledMobMenu
          className="cvp-mob-menu"
          model={navItems.map((item) => getItem(item, userInfo))}
        />
      )}
    />
  );
};

export const StyledMobMenu = styled(Menu)`
  &.cvp-mob-menu {
    width: 100%;
    margin-top: 3rem;
    padding-top: 3rem;
    border-color: transparent;

    .p-menuitem-link {
      padding: 1rem 1rem;

      &:hover:not(:disabled) {
        background-color: var(--primary-50);
        -webkit-transition: all ease-out 0.3s;
        -moz-transition: all ease-out 0.3s;
        -o-transition: all ease-out 0.3s;
        transition: all ease-out 0.3s;

        .p-menuitem-text,
        .p-menuitem-icon {
          color: var(--primary-500);
          -webkit-transition: all ease-out 0.3s;
          -moz-transition: all ease-out 0.3s;
          -o-transition: all ease-out 0.3s;
          transition: all ease-out 0.3s;
        }
      }

      &:focus {
        box-shadow: none;
      }
    }

    .active {
      background-color: var(--primary-50);

      .p-menuitem-text,
      .p-menuitem-icon {
        color: var(--primary-500);
        font-weight: 700;
      }

      &:hover:not(:disabled) {
        .p-menuitem-text,
        .p-menuitem-icon {
          font-weight: 500;
          -webkit-transition: all ease-out 0.3s;
          -moz-transition: all ease-out 0.3s;
          -o-transition: all ease-out 0.3s;
          transition: all ease-out 0.3s;
        }
      }
    }
  }
`;
